import { render, staticRenderFns } from "./ProcedureDomainConnectInput.vue?vue&type=template&id=50d266a1&"
import script from "./ProcedureDomainConnectInput.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainConnectInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports